<template>
  <div>
    <b-tabs small>
      <b-tab v-for="(e, i) in expeditions" :key="i" @click="displayTab(e.expedition)" small
        :active="e.expedition === 'pendente_de_separacao'">
        <template v-slot:title>
          <span>
            <center>
              {{ e.name }}<br />
              <i style="cursor: pointer" class="fe fe-help-circle" v-b-tooltip.hover.bottomright="descriptionAboutTheTab(e.expedition)
                "></i>
              <i :class="e.icon"></i>
              <b-badge :variant="e.color" style="position: relative">
                {{ e.cont }}
              </b-badge>
            </center>
          </span>
        </template>
        <b-container fluid style="background-color: #fff">
          <FilterComponent :expedition="e" :options_por_conta="options_por_conta"
            :oprtions_available_channels="availableChannels" />
          <TablesComponent :filters="e.filters" :url="e.url" :url_next="e.url_next" :expedition="e.expedition"
            :checkFaturador="checkFaturador" :usr_orders="usr_orders" :showAll="showAll" :apps="apps" :iTabs="i"
            :expeditionsTabs="expeditions" />
        </b-container>
      </b-tab>
    </b-tabs>
    <ListaDeSepacao />
  </div>
</template>
<script>
import ListaDeSepacao from "./Support/ListaDeSepacao.vue";
import barramento from "../../../barramento";
import FilterComponent from "./Filter.vue";
import TablesComponent from "./Tables.vue";

export default {
  name: "Tabs",
  props: [
    "options_por_conta",
    "checkFaturador",
    "usr_orders",
    "availableChannels",
    "apps",
  ],
  components: { FilterComponent, TablesComponent, ListaDeSepacao },
  beforeMount() {
    for (var i = 0; i < this.expeditions.length; i++) {
      this.indexExpedition[this.expeditions[i].expedition] = i;
    }
  },
  beforeDestroy() {
    for (var i = 0; i < this.expeditions.length; i++) {
      barramento.$off(`count_${this.expeditions[i].expedition}`);
      barramento.$off(`count_decremente_${this.expeditions[i].expedition}`);
    }
  },
  created() {
    for (var i = 0; i < this.expeditions.length; i++) {
      barramento.$on(`count_${this.expeditions[i].expedition}`, (obj) => {
        this.expeditions[this.indexExpedition[obj.expedition]].cont = obj.valor;
      });
      barramento.$on(
        `count_decremente_${this.expeditions[i].expedition}`,
        (obj) => {
          this.expeditions[this.indexExpedition[obj.expedition]].cont -=
            obj.valor;

          if (!!obj.index) this.expeditions[obj.index].cont += obj.valor;
          else
            this.expeditions[this.indexExpedition[obj.expedition] + 1].cont +=
              obj.valor;
        }
      );
    }
  },
  data() {
    return {
      indexExpedition: [],
      showAll: "pendente_de_separacao",
      expeditions: [
        {
          name: "A combinar",
          expedition: "a_combinar",
          icon: "fas fa-thumbs-up",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "partial_payment",
            sub_status: null,
          },
        },
        {
          name: "Pendente de separação",
          expedition: "pendente_de_separacao",
          icon: "fas fa-clipboard-list",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: ["approved", "waiting_invoice"],
            sub_status: 'waiting_picking'
          },
        },
        {
          name: "Em separação",
          expedition: "em_separacao",
          icon: "fas fa-dolly",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "approved",
            sub_status: "processing_picking",
          },
        },
        {
          name: "Separados",
          expedition: "separado",
          icon: "fas fa-cubes",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: ["partial_payment","approved","waiting_invoice","invoiced","partial_invoiced","shipping_informed","shipped","delivered","partial_shipped","partial_delivered","picking"],
            sub_status: "pending_invoice",
          },
        },
        {
          name: "Aguardando NF-e",
          expedition: "aguardando_nota_fiscal",
          icon: "fas fa-money-check",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: ["approved"],
            sub_status: "waiting_invoice",
          },
        },
        {
          name: "Erro NF-e",
          expedition: "erro_ao_gerar_nota_fiscal",
          icon: "fas fa-exclamation-triangle",
          cont: 0,
          color: "warning",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "invoice_error",
            sub_status: null,
          },
        },
        {
          name: "Aguardando Etiqueta",
          expedition: "etiqueta",
          icon: "fas fa-print",
          cont: 0,
          color: "warning",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "invoiced",
            sub_status: "waiting_expedition",
            has_label: "false",
          },
        },
        {
          name: "Pronto pra embalar",
          expedition: "pronto_para_embalar",
          icon: "fas fa-boxes",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: ["shipping_informed", "invoiced"],
            sub_status: "waiting_expedition",
            needsEan: "true",
            has_label: "true",
            delivery_type: ['standard','express','onehour','pickup','economy','guaranteed','scheduled','international'],
          },
        },
        {
          name: "Aguardando retirada",
          expedition: "aguardando_retirada",
          icon: "fas fa-dolly-flatbed",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "shipping_informed",
            sub_status: "processing_expedition",
          },
        },
        {
          name: "Em trânsito",
          expedition: "em_transito",
          icon: "fas fa-truck",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "shipped",
            sub_status: null,
          },
        },
        {
          name: "Entregue",
          expedition: "entregue",
          icon: "fas fa-warehouse",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "delivered",
            sub_status: null,
          },
        },
      ],
    };
  },
  methods: {
    descriptionAboutTheTab(expedition) {
      var mensagem;
      switch (expedition) {
        case "a_combinar":
          mensagem = this.$t("Pedidos onde a forma de entrega é “a combinar”");
          break;
        case "pendente_de_separacao":
          mensagem =
          this.$t("Todos os pedidos que já podem ser separados, nessa fase poderá imprimir a lista se preferir.");
          break;
        case "em_separacao":
          mensagem =
          this.$t("Aqui encontram-se os pedidos em processo de separação no estoque.");
          break;
        case "separado":
          mensagem =
          this.$t("Todos os pedidos que já tiveram os seus itens separados no estoque.");
          break;
        case "aguardando_nota_fiscal":
          mensagem = this.$t("Pedidos que ainda precisam gerar a nota fiscal.");
          break;
        case "erro_ao_gerar_nota_fiscal":
          mensagem =
          this.$t("Se o pedido está aqui, significa que ocorreu algum problema com a geração automática da nota fiscal do seu pedido.");
          break;
        case "etiqueta":
          mensagem =
          this.$t("A etiqueta para os determinados pedidos ainda não estão disponíveis.");
          break;
        case "pronto_para_embalar":
          mensagem =
          this.$t("Todos os pedidos aqui encontram-se prontos para serem embalados.");
          break;
        case "aguardando_retirada":
          mensagem = this.$t("Tudo certo, pedido tá pronto para ser retirado.");
          break;
        case "em_transito":
          mensagem = this.$t("Os pedidos estão a caminho dos seus destinos.");
          break;
        case "entregue":
          mensagem = this.$t("Todos os pedidos que já foram entregues, por aqui tá tudo certo.");
          break;
      }
      return mensagem;
    },
    displayTab(expedition) {
      this.showAll = expedition;
      let filter = this.expeditions.filter(function(row) {
        return row.expedition == expedition
      }).shift();
      barramento.$emit(`expedition_loding_${expedition}`, filter.filters);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/Tabs.vue